import { Typography } from "antd";
import { createStyles } from "antd-style";

import type { AvE2EProps } from "@av/components/types";

import type { TitleProps as AntdTitleProps } from "antd/es/typography/Title";

const { Title: AntdTitle } = Typography;

const useStyles = createStyles(
  ({ css }, props: { alignWithIcon?: boolean; inline?: boolean; unBold?: boolean }) => ({
    titleText: css`
      &.ant-typography {
        margin: 0;
        margin-bottom: ${props.alignWithIcon ? "10px" : ""};
      }
    `,
  })
);

type TitleProps = AntdTitleProps &
  AvE2EProps & {
    alignWithIcon?: boolean;
    unBold?: boolean;
  };

export function CustomTitle(props: TitleProps) {
  const { testIdPrefix, alignWithIcon, unBold = false, ...rest } = props;
  const { styles } = useStyles({ alignWithIcon, unBold });

  return (
    <AntdTitle
      rootClassName={styles.titleText}
      data-testid={`${testIdPrefix}-title`}
      style={unBold ? { fontWeight: "normal" } : {}}
      {...rest}
    />
  );
}
